import React from 'react';
import { styled, ThemeProvider } from '@mui/material/styles';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Graph from './Graph/Graph';
import GraphRead from './GraphRead/GraphRead';
import Strobe from './Strobe/Strobe';
import KayakingHome from './Kayaking/KayakingHome';
import GraphLanding from './Landing/GraphLanding';
import LogoOptions from './Landing/LogoOptions';
import { muiTheme } from './muiTheme';
import { GoogleEditorGate } from './Auth/GoogleEditorGate';

const landingVariantRoutes = Array.from({ length: 20 }, (_, index) => String(index + 1));
const HOW_YOU_MET_US_HOSTS = new Set(['howyoumet.us', 'www.howyoumet.us']);

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  minHeight: '100dvh',
  overflowX: 'hidden',
  backgroundColor: 'black',
}));

function AppRoutes() {
  const rootLandingVariantId = HOW_YOU_MET_US_HOSTS.has(window.location.hostname) ? '16' : undefined;

  return (
    <Routes>
      <Route path="/edit" element={<GoogleEditorGate><Graph /></GoogleEditorGate>} />
      <Route path="/edit/:graphName" element={<GoogleEditorGate><Graph /></GoogleEditorGate>} />
      <Route path="/map" element={<GraphLanding />} />
      <Route path="/map/:graphName" element={<GraphRead />} />
      <Route path="/graph" element={<GraphLanding />} />
      <Route path="/graph/:graphName" element={<GraphRead />} />
      {landingVariantRoutes.map((variantId) => (
        <Route
          key={variantId}
          path={`/${variantId}`}
          element={<GraphLanding variantId={variantId} />}
        />
      ))}
      <Route path="/logo-options" element={<LogoOptions />} />
      <Route path="/kayaking" element={<KayakingHome />} />
      <Route path="/party" element={<Strobe postAuthPath="/party" />} />
      <Route path="/party-demo" element={<Strobe postAuthPath="/party-demo" demoMode />} />
      <Route path="/strobe" element={<Strobe postAuthPath="/strobe" />} />
      <Route path="/spotify-callback" element={<Strobe />} />
      <Route path="/" element={<GraphLanding variantId={rootLandingVariantId} />} />
      <Route path="*" element={<GraphLanding />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={muiTheme}>
        <Root>
          <AppRoutes />
        </Root>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
